<template>
  <div>
    <my-header></my-header>

    <div class="section-container">
      <side-nav
        :menuItems="menuItems"
        class="side-nav"
      />

      <div class="content-box">
        <h2>Game event (id {{gvntId}})</h2>
        <router-view></router-view>
      </div>
    </div>

  </div>
</template>

<script>
import MyHeader from './Header.vue';
import SideNav from './SideNav.vue';

export default {
  name: 'Gvnt',

  components: {
    MyHeader,
    SideNav,
  },

  props: {
    gvntId: {
      type: Number,
      required: true,
    },
  },

  computed: {

    /** @returns {Object[]} */
    menuItems() {
      const thisObj = this;

      return [
        {
          title: 'Info',
          route: {name: 'gvnt_info', params: {gvntId: this.gvntId}},
          isActive() {
            const routeName = thisObj.$route.name;
            return (routeName === 'gvnt_info') || (routeName === 'gvnt_edit');
          },
        },
        {
          title: 'Edit client min version',
          route: {name: 'gvnt_edit_client_min_version', params: {gvntId: this.gvntId}},
        },
      ];
    },
  },
}
</script>

<style scoped>
.section-container {
  display: flex;
}

.side-nav {
  margin-right: 3em;
}

.content-box {
  width: 600px;
  padding-top: 1em;
}
</style>
